import type { ShareOptions } from 'react-native';
import { Alert } from 'react-native';
import { Linking } from 'react-native';
import { Platform, Share } from 'react-native';

//  https://reactnative.dev/docs/share#share
export const openNativeShare = async (props: OpenNativeShareProps) => {
  const { message, url, options } = props;

  if (Platform.OS === 'web') return;

  await Share.share(
    {
      message: `${message}\n${url}`,
      url,
    },
    options,
  );
};

/**
 * Opens the provided URL if it's supported.
 */
export async function openUrl(url: string, errorMessage: string) {
  const isSupported = await Linking.canOpenURL(url);

  if (!isSupported) {
    Alert.alert(errorMessage);

    return;
  }

  await Linking.openURL(url);
}

//
// ─── TYPES ──────────────────────────────────────────────────────────────────────
//

type OpenNativeShareProps = Readonly<{
  message: string;
  url: string;
  options?: ShareOptions;
}>;
